import { ITableCol } from '@data/interfaces/itable.interface';

/**
 * Columnas para la tabla de comunicaciones (emails)
 */
export const EMAIL_COLUMNS: ITableCol[] = [
  {
    type: 'text',
    field: '_id',
    header: 'ID',
    showFilter: false,
    dataType: 'link'
  },
  {
    type: 'text',
    field: 'campaignStrategyName',
    header: 'Estrategia',
    showFilter: true
  },
  {
    type: 'text',
    field: 'leaseNumber',
    header: 'Lease',
    showFilter: true
  },
  {
    type: 'text',
    field: 'clientName',
    header: 'Cliente',
    showFilter: true
  },
  {
    type: 'text',
    field: 'recipientEmail',
    header: 'Email Destinatario',
    showFilter: true
  },
  {
    type: 'text',
    field: 'subject',
    header: 'Asunto',
    showFilter: true
  },
  {
    type: 'enum',
    field: 'channelType',
    header: 'Canal',
    showFilter: true,
    dataType: 'enum',
    enum: {
      email: 'Email',
      sms: 'SMS',
      whatsapp: 'WhatsApp',
      call: 'Llamada'
    },
    enumColor: {
      email: 'primary',
      sms: 'info',
      whatsapp: 'success',
      call: 'warning'
    }
  },
  {
    type: 'enum',
    field: 'status',
    header: 'Estado',
    showFilter: true,
    dataType: 'enum',
    enum: {
      PENDING: 'Pendiente',
      SENT: 'Enviado',
      DELIVERED: 'Entregado',
      OPENED: 'Abierto',
      CLICKED: 'Click',
      BOUNCED: 'Rebotado',
      FAILED: 'Fallido'
    },
    enumColor: {
      PENDING: 'warning',
      SENT: 'info',
      DELIVERED: 'success',
      OPENED: 'success',
      CLICKED: 'success',
      BOUNCED: 'danger',
      FAILED: 'danger'
    }
  },
  {
    type: 'date',
    field: 'sentAt',
    header: 'Fecha de Envío',
    showFilter: true,
    dataType: 'date'
  },
  {
    type: 'date',
    field: 'deliveredAt',
    header: 'Fecha de Entrega',
    showFilter: true,
    dataType: 'date'
  },
  {
    type: 'date',
    field: 'openedAt',
    header: 'Fecha de Apertura',
    showFilter: true,
    dataType: 'date'
  },
  {
    type: 'text',
    field: 'engagementDisplay',
    header: 'Engagement',
    showFilter: false
  }
];

/**
 * Acciones disponibles para la tabla de comunicaciones
 */
export const EMAIL_ACTIONS = [
  {
    title: 'Ver Detalle',
    icon: 'fa-solid fa-eye',
    action: 'VIEW',
    color: 'primary',
    permission: ['dripping', 'get-by-id'] as [string, string]
  },
  {
    title: 'Ver Preview HTML',
    icon: 'fa-solid fa-code',
    action: 'PREVIEW',
    color: 'info',
    permission: ['dripping', 'get-by-id'] as [string, string]
  },
  {
    title: 'Tracking Timeline',
    icon: 'fa-solid fa-timeline',
    action: 'TRACKING',
    color: 'secondary',
    permission: ['dripping', 'get-by-id'] as [string, string]
  },
  {
    title: 'Reenviar',
    icon: 'fa-solid fa-paper-plane',
    action: 'RESEND',
    color: 'success',
    permission: ['dripping', 'resend'] as [string, string],
    rule: { 
      field: 'status', 
      value: ['FAILED', 'BOUNCED'], 
      type: 'in' 
    }
  }
];

/**
 * Información de estados de email
 */
export const EMAIL_STATUS_INFO = {
  PENDING: {
    label: 'Pendiente',
    icon: 'fa-solid fa-clock',
    color: '#FFA726',
    description: 'En cola para envío'
  },
  SENT: {
    label: 'Enviado',
    icon: 'fa-solid fa-paper-plane',
    color: '#42A5F5',
    description: 'Email enviado al servidor'
  },
  DELIVERED: {
    label: 'Entregado',
    icon: 'fa-solid fa-check',
    color: '#66BB6A',
    description: 'Email entregado en bandeja de entrada'
  },
  OPENED: {
    label: 'Abierto',
    icon: 'fa-solid fa-envelope-open',
    color: '#26A69A',
    description: 'Email abierto por destinatario'
  },
  CLICKED: {
    label: 'Click',
    icon: 'fa-solid fa-hand-pointer',
    color: '#9C27B0',
    description: 'Usuario hizo click en enlace'
  },
  BOUNCED: {
    label: 'Rebotado',
    icon: 'fa-solid fa-exclamation-triangle',
    color: '#FF7043',
    description: 'Email rebotado (hard/soft bounce)'
  },
  FAILED: {
    label: 'Fallido',
    icon: 'fa-solid fa-times-circle',
    color: '#EF5350',
    description: 'Error al enviar email'
  }
};

/**
 * Tipos de eventos de tracking
 */
export const TRACKING_EVENT_TYPES = {
  SENT: { 
    label: 'Enviado', 
    icon: 'fa-solid fa-paper-plane', 
    color: '#42A5F5' 
  },
  DELIVERED: { 
    label: 'Entregado', 
    icon: 'fa-solid fa-check', 
    color: '#66BB6A' 
  },
  OPENED: { 
    label: 'Abierto', 
    icon: 'fa-solid fa-envelope-open', 
    color: '#26A69A' 
  },
  CLICKED: { 
    label: 'Click', 
    icon: 'fa-solid fa-hand-pointer', 
    color: '#9C27B0' 
  },
  BOUNCED: { 
    label: 'Rebotado', 
    icon: 'fa-solid fa-exclamation-triangle', 
    color: '#FF7043' 
  },
  FAILED: { 
    label: 'Fallido', 
    icon: 'fa-solid fa-times-circle', 
    color: '#EF5350' 
  }
};

/**
 * Iconos de canales de comunicación
 */
export const CHANNEL_ICONS = {
  email: 'fa-solid fa-envelope',
  sms: 'fa-solid fa-comment-sms',
  whatsapp: 'fa-brands fa-whatsapp',
  call: 'fa-solid fa-phone'
};
